export const routeMetadata = {
  "/": {
    title: "Weizhi Works | Native & Cross-Platform Mobile App Developer",
    description:
      "Professional native and cross-platform mobile app developer building production-ready iOS, React Native, Expo, and Flutter apps from idea to launch.",
    url: "https://weizhi.me/",
  },
  "/about": {
    title: "About Weizhi | Production Mobile App Developer",
    description:
      "Learn about Weizhi, a professional native and cross-platform mobile app developer with industry experience since 2014 building complex production apps.",
    url: "https://weizhi.me/about",
  },
  photos: {
    title: "Photos by Weizhi | Streets, Stations, Parks, and Daily Life",
    description:
      "A personal photo journal by Weizhi with categorized street, subway, building, park, and daily life photography.",
    url: "https://photos.weizhi.me/",
  },
  dashboard: {
    title: "Dashboard",
    description: "",
    url: "https://dashboard.weizhi.me/",
  },
};

